const Stars = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path
        d="M12.6667 6L13.5 4.16667L15.3333 3.33333L13.5 2.5L12.6667 0.666667L11.8333 2.5L10 3.33333L11.8333 4.16667L12.6667 6Z"
        fill={color}
      />
      <path
        d="M12.6667 10L11.8333 11.8333L10 12.6667L11.8333 13.5L12.6667 15.3333L13.5 13.5L15.3333 12.6667L13.5 11.8333L12.6667 10Z"
        fill={color}
      />
      <path
        d="M7.66667 6.33333L6 2.66667L4.33333 6.33333L0.666667 8L4.33333 9.66667L6 13.3333L7.66667 9.66667L11.3333 8L7.66667 6.33333ZM6.66 8.66L6 10.1133L5.34 8.66L3.88667 8L5.34 7.34L6 5.88667L6.66 7.34L8.11333 8L6.66 8.66Z"
        fill={color}
      />
    </svg>
  );
};
export default Stars;
